import axiosInstance from "../../../helpers/api";

export const getAllTeachers = (body) => {
  return axiosInstance.get("/superadmin/teachers", body);
};

export const editTeachers = (formData) => {
  return axiosInstance.post(
    `/superadmin/teachers/${formData.id}`,
    formData.formData
  );
};

export const createTeachers = (formData) => {
  return axiosInstance.post("/superadmin/teachers", formData);
};

export const deleteTeacher = (id) => {
  return axiosInstance.delete(`/superadmin/teachers/${id}`);
};

export const addTeacherAdmin = (formData) => {
  return axiosInstance.post("/superadmin/users/add-teacher-admin", formData);
};
